import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { DxDataGridComponent } from 'devextreme-angular';


import CustomStore from 'devextreme/data/custom_store';
import { lastValueFrom } from 'rxjs';
@Component({
  selector: 'app-deduction',
  templateUrl: './deduction.component.html',
  styleUrls: ['./deduction.component.scss']
})
export class DeductionComponent implements OnInit {
  button = {}
  TypeValue: any;
  private handleError: HandleError;
  TaxableStatus: {};
  InsuranceStatus: {}
  customDataSource: any;
  type: number;
  date = new Date()
  addpopup: string = '';
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  useDeductTypeAccounts: boolean = false;
accountsDataSource: any;

  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public gt: genericCustomStoreService
    , private validation: CheckValidation, public Objects: ObjectsService, public translate: TranslateService) {
    gt.seturl("DeductType");
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY);
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.TypeValue = Objects.TypeValue;
    this.TaxableStatus = Objects.TaxableStatus
    this.InsuranceStatus = Objects.InsuranceStatus
    this.button = Objects.button;

    this.validateAsync = this.validateAsync.bind(this);
    this.validateAsyncForEn = this.validateAsyncForEn.bind(this)

    this.setCellValuetypevalue = this.setCellValuetypevalue.bind(this);
  }
  ngOnInit(): void {
    this.getAccounts();
    this.gt.dropdown('Settings/all').subscribe((res: any) => {
      
      const data = res?.data ?? res;
      this.useDeductTypeAccounts = data?.useDeductTypeAccounts || false;
    });


  }
getAccounts() {
  this.accountsDataSource = new CustomStore({
    key: 'id',

    load: (loadOptions: any) => {
      const take = loadOptions.take || 20;
      const skip = loadOptions.skip || 0;
      const pageIndex = Math.floor(skip / take) + 1;
      
      // قراءة نص البحث الممرر من الـ SelectBox
      const searchValue = loadOptions.searchValue || '';

      const url = `api/JournalEntry/GetAccountsByType?Type=0&PageNumber=${pageIndex}&PageSize=${take}&Search=${encodeURIComponent(searchValue)}`;

      return lastValueFrom(this.gt.GetAccounts(url))
        .then((response: any) => {
          return {
            data: response?.items || [],
            totalCount: response?.totalCount || 0
          };
        })
        .catch(() => ({ data: [], totalCount: 0 }));
    },

    byKey: (key: any) => {
      if (key === null || key === undefined) return Promise.resolve(null);
      // يجلب الحساب بالـ ID أو بالـ Search لو الـ API مش بتدعم ID مباشر
      return lastValueFrom(
        this.gt.GetAccounts(`api/JournalEntry/GetAccountsByType?Type=0&Search=${key}`)
      ).then((res: any) => {
        const items = res?.items || res;
        if (Array.isArray(items)) {
          return items.find((x: any) => x.id === key) || null;
        }
        return items;
      });
    }
  });
}

onEditorPreparing(e: any) {
  if (e.parentType === 'dataRow' && e.dataField === 'accountId') {
    e.editorOptions.disabled = !this.useDeductTypeAccounts;

    // إعدادات الـ SelectBox
    e.editorOptions.searchEnabled = true;
    e.editorOptions.searchTimeout = 600;
    e.editorOptions.minSearchLength = 0; // يظهر أول 20 عنصر فوراً عند الفتح
    e.editorOptions.showClearButton = true;
    
    // ربط الـ DataSource مع تفعيل الـ Paging
    e.editorOptions.dataSource = {
      store: this.accountsDataSource,
      paginate: true,
      pageSize: 20
    };

    // إجبار الـ SelectBox يرسل كويري البحث للـ Store بدل ما يفلتر الملاحظات محلياً
    e.editorOptions.searchExpr = ['nameAr', 'nameEn', 'code'];
  }

  this.gt.onEditorPreparing(e);
}
  validateAsync(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "DeductType");
  }
  validateAsyncForEn(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "DeductType", 'CheckName', 'NameEn');
  }


  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
    options.newData.dateOfRegistration = this.date;
    if (!this.useDeductTypeAccounts) {
      options.newData.accountId = null;
    }
  }
  onInitNewRow(e: any) {
    e.data.dateOfRegistration = this.date
    this.addpopup = this.translate.instant('tableinfo.addbutton')
    if (!this.useDeductTypeAccounts) {
      e.data.accountId = null;
    }
  }
  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }

  addrowfun(name: string) {
    return this.gt.addrow(name)
  }
  setCellValuetypevalue(newData: any, value: any) {
    newData.valueType = value
    this.type = value
  }

}
